import { Row } from 'antd'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
const TextTitleBold = styled.h2`
  font-family: 'IBMPlexSansThaiBold';
`
const Alldash = (props) => {
  const { option, data, dataDetailSearchProjectList, word } = props
  const [newData, setNewData] = useState([])
  const [total, setTotal] = useState(0)
  useEffect(() => {
    if (data.length != 0 && option.length != 0) {
      setTotal(data.project_total)
      let arrayData = []
      option.map((item) => {
        if (data.summary[item.id] != undefined) {
          arrayData.push({
            status_id: data.summary[item.id].status_id,
            percent: data.summary[item.id].percent,
            total: data.summary[item.id].total,
            status_name: data.summary[item.id].status_name,
          })
        } else {
          arrayData.push({
            status_id: item.id,
            percent: 0,
            total: 0,
            status_name: item.name,
          })
        }
      })

      setNewData(arrayData)
    }
  }, [data, option])
  const history = useHistory()
  const [linkURL1, setLinkURL1] = useState()
  const [linkURL2, setLinkURL2] = useState()
  // const timeout = setTimeout(() => {
  //   window.history.back()
  // }, 2000);
  const goprojectlist = async (valueID, valueName) => {
    let aaa = linkURL1
    aaa.push(`status_id=${valueID}`)
    setLinkURL2(aaa.join('&'))
    history.push(aaa.join('&'))
  }

  useEffect(() => {
    let arr = []
    let aaa = `/project-list?start_date=${dataDetailSearchProjectList?.start_date}&end_date=${dataDetailSearchProjectList?.end_date}`

    arr.push(aaa)

    dataDetailSearchProjectList?.company_id
      ? arr.push(`company_id=${dataDetailSearchProjectList?.company_id}`)
      : _
    dataDetailSearchProjectList?.operation_id
      ? arr.push(`operation_id=${dataDetailSearchProjectList?.operation_id}`)
      : _
    dataDetailSearchProjectList?.suboperation_id
      ? arr.push(`suboperation_id=${dataDetailSearchProjectList?.suboperation_id}`)
      : _
    dataDetailSearchProjectList?.project_group_id
      ? arr.push(`project_group_id=${dataDetailSearchProjectList?.project_group_id}`)
      : _
    dataDetailSearchProjectList?.subproject_group_id
      ? arr.push(
        `subproject_group_id=${dataDetailSearchProjectList?.subproject_group_id}`,
      )
      : _
    dataDetailSearchProjectList?.impact_type_id
      ? arr.push(`impact_type_id=${dataDetailSearchProjectList?.impact_type_id}`)
      : _
    setLinkURL1(arr)
  }, [dataDetailSearchProjectList])

  return (
    <div className="aldash-in-container">
      <Row className="onerows">
        <div className="left">
          <h1>{total}</h1>
          <TextTitleBold>{word['projects']}</TextTitleBold>
        </div>
        <div className="right">
          <div
            className="progress-bar"
            style={
              total === 0 ? { backgroundColor: '#efefef' } : { backgroundColor: 'unset' }
            }
          >
            <div
              className="status_saved itemstyle"
              style={{ width: `${newData[1]?.percent}%` }}
            ></div>
            <div
              className="status_register itemstyle"
              style={{ width: `${newData[3]?.percent}%` }}
            ></div>
            <div
              className="status_kickoff itemstyle"
              style={{ width: `${newData[5]?.percent}%` }}
            ></div>
            <div
              className="status_waiting_app_onhold itemstyle"
              style={{ width: `${newData[16]?.percent}%` }}
            ></div>
            <div
              className="status_onhold  itemstyle"
              style={{ width: `${newData[6]?.percent}%` }}
            ></div>
            <div
              className="status_completed itemstyle"
              style={{ width: `${newData[8]?.percent}%` }}
            ></div>
            <div
              className="status_completed_delay itemstyle"
              style={{ width: `${newData[13]?.percent}%` }}
            ></div>
            <div
              className="status_cancelled itemstyle"
              style={{ width: `${newData[12]?.percent}%` }}
            ></div>
            <div
              className="status_waiting_app_regis itemstyle"
              style={{ width: `${newData[2]?.percent}%` }}
            ></div>
            <div
              className="status_approve_kickoff itemstyle"
              style={{ width: `${newData[4]?.percent}%` }}
            ></div>
            <div
              className="status_app_complete itemstyle"
              style={{ width: `${newData[7]?.percent}%` }}
            ></div>
          </div>
        </div>
      </Row>
      <Row className="tworows">
        <h3>{word['Project_Status']}</h3>
      </Row>
      <Row className="threerows">
        <div className="inbox">
          <div className="point status_saved"></div>
          <div className="pertext-content">
            <h1
              onClick={() =>
                goprojectlist(newData[1]?.status_id, newData[1]?.status_name)
              }
            >
              {newData[1]?.total}
            </h1>
            <Row className="percent-area">
              <text>
                {newData[1]?.status_name}
                <text className="p2">({newData[1]?.percent}%)</text>
              </text>
            </Row>
          </div>
        </div>
        <div className="inbox">
          <div className="point status_onhold"></div>
          <div className="pertext-content">
            <h1
              onClick={() =>
                goprojectlist(newData[6]?.status_id, newData[6]?.status_name)
              }
            >
              {newData[6]?.total}
            </h1>
            <Row className="percent-area">
              <text>
                {newData[6]?.status_name}
                <text className="p2">({newData[6]?.percent}%)</text>
              </text>
            </Row>
          </div>
        </div>
        <div className="inbox">
          <div className="point status_waiting_app_regis"></div>
          <div className="pertext-content">
            <h1
              onClick={() =>
                goprojectlist(newData[2]?.status_id, newData[2]?.status_name)
              }
            >
              {newData[2]?.total}
            </h1>
            <Row className="percent-area">
              <text>
                {newData[2]?.status_name}
                <text className="p2">({newData[2]?.percent}%)</text>
              </text>
            </Row>
          </div>
        </div>
        <div className="inbox">
          <div className="point status_register"></div>
          <div className="pertext-content">
            <h1
              onClick={() =>
                goprojectlist(newData[3]?.status_id, newData[3]?.status_name)
              }
            >
              {newData[3]?.total}
            </h1>
            <Row className="percent-area">
              <text>
                {newData[3]?.status_name}
                <text className="p2">({newData[3]?.percent}%)</text>
              </text>
            </Row>
          </div>
        </div>
        <div className="inbox">
          <div className="point status_completed"></div>
          <div className="pertext-content">
            <h1
              onClick={() =>
                goprojectlist(newData[8]?.status_id, newData[8]?.status_name)
              }
            >
              {newData[8]?.total}
            </h1>
            <Row className="percent-area">
              <text>
                {newData[8]?.status_name}
                <text className="p2">({newData[8]?.percent}%)</text>
              </text>
            </Row>
          </div>
        </div>
        <div className="inbox ">
          <div className="point status_approve_kickoff"></div>
          <div className="pertext-content">
            <h1
              onClick={() =>
                goprojectlist(newData[4]?.status_id, newData[4]?.status_name)
              }
            >
              {newData[4]?.total}
            </h1>
            <Row className="percent-area">
              <text>
                {newData[4]?.status_name}
                <text className="p2">({newData[4]?.percent}%)</text>
              </text>
            </Row>
          </div>
        </div>
        <div className="inbox">
          <div className="point status_kickoff"></div>
          <div className="pertext-content">
            <h1
              onClick={() =>
                goprojectlist(newData[5]?.status_id, newData[5]?.status_name)
              }
            >
              {newData[5]?.total}
            </h1>
            <Row className="percent-area">
              <text>
                {newData[5]?.status_name}
                <text className="p2">({newData[5]?.percent}%)</text>
              </text>
            </Row>
          </div>
        </div>
        <div className="inbox">
          <div className="point status_completed_delay"></div>
          <div className="pertext-content">
            <h1
              onClick={() =>
                goprojectlist(newData[13]?.status_id, newData[13]?.status_name)
              }
            >
              {newData[13]?.total}
            </h1>
            <Row className="percent-area">
              <text>
                {newData[13]?.status_name}
                <text className="p2">({newData[13]?.percent}%)</text>
              </text>
            </Row>
          </div>
        </div>
        <div className="inbox">
          <div className="point status_app_complete"></div>
          <div className="pertext-content">
            <h1
              onClick={() =>
                goprojectlist(newData[7]?.status_id, newData[7]?.status_name)
              }
            >
              {newData[7]?.total}
            </h1>
            <Row className="percent-area">
              <text>
                {newData[7]?.status_name}
                <text className="p2">({newData[7]?.percent}%)</text>
              </text>
            </Row>
          </div>
        </div>
        <div className="inbox">
          <div className="point status_waiting_app_onhold"></div>
          <div className="pertext-content">
            <h1
              onClick={() =>
                goprojectlist(newData[16]?.status_id, newData[16]?.status_name)
              }
            >
              {newData[16]?.total}
            </h1>
            <Row className="percent-area">
              <text>
                {newData[16]?.status_name}
                <text className="p2">({newData[16]?.percent}%)</text>
              </text>
            </Row>
          </div>
        </div>

        <div className="inbox">
          <div className="point status_cancelled"></div>
          <div className="pertext-content">
            <h1
              onClick={() =>
                goprojectlist(newData[12]?.status_id, newData[12]?.status_name)
              }
            >
              {newData[12]?.total}
            </h1>
            <Row className="percent-area">
              <text>
                {newData[12]?.status_name}
                <text className="p2">({newData[12]?.percent}%)</text>
              </text>
            </Row>
          </div>
        </div>
      </Row>
    </div>
  )
}
export default Alldash
